module.exports = __webpack_public_path__ + "img/premium_slideimage04.f4aeb37b.jpg";